import { checkEmail, checkNotEmpty } from '../../helpers/validators';
export const validateEmail = ({ value, required }) => {
    if (required) {
        return checkNotEmpty({ value }) || checkEmail({ value });
    }
    return value ? checkEmail({ value, type: 'lostfocus' }) : null;
};
